/**
 * Internal: only ProjectReferenceAdapterBridge must import from this file.
 */

import type { ProjectReferenceSnapshot } from './project-reference-adapter.shared';
import { projectReferenceAdapter } from './project-reference-adapter.shared';

export function setProjectReferenceSnapshot(next: ProjectReferenceSnapshot): void {
  projectReferenceAdapter._setSnapshot(next);
}
